import { Subject } from 'rxjs';

const subject = new Subject();

export const managePaymentTourGuideService = {
    emitReload: val => subject.next(val),
    reload: () => subject.asObservable()
};